import SearchableSelect, { type SearchableSelectOption } from './SearchableSelect';

type CoursePickerProps = {
  value: string;
  onValueChange: (value: string) => void;
  options: SearchableSelectOption[];
  placeholder: string;
  searchPlaceholder?: string;
  searchTerm?: string;
  onSearchTermChange?: (value: string) => void;
  loading?: boolean;
  emptyMessage?: string;
  sentinelOption?: SearchableSelectOption;
  disabled?: boolean;
  triggerId?: string;
  inputTestId?: string;
  maxVisibleOptions?: number;
};

export const CoursePicker: React.FC<CoursePickerProps> = ({
  searchPlaceholder = 'Search courses...',
  ...props
}) => <SearchableSelect {...props} searchPlaceholder={searchPlaceholder} />;

export default CoursePicker;
